import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { AdvisorApiService } from './advisor.service';
import {
  loadAdvisorList,
  loadAdvisorListSuccess,
  loadAdvisorListFailure,
} from './advisor.actions';

@Injectable()
export class AdvisorEffects {
  private actions$ = inject(Actions);
  private advisorService = inject(AdvisorApiService);

  loadAdvisorList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadAdvisorList),
      mergeMap(() =>
        this.advisorService.getAdvisorList().pipe(
          map((response: any) => {
            if (response.status === 'Failed') {
              return loadAdvisorListFailure({ error: response.message });
            }
            return loadAdvisorListSuccess({ data: response.data });
          }),
          catchError((error) => of(loadAdvisorListFailure({ error })))
        )
      )
    )
  );
}
